module.exports = __webpack_public_path__ + "static/media/Premiumbadge.f78d7b2e.svg";